import {gql} from '@apollo/client';
import {REVIEW_SUMMARY_FRAGMENT, STAFF} from '../../graphql/fragments';

export const REVIEW_PAGE_QUERY = gql`
  query GetReviewPage($staffId: UUID!, $curoSync: Boolean) {
    staffReviews(staffId: $staffId, curoSync: $curoSync) {
      ...ReviewSummaryFragment
    }
  }
  ${REVIEW_SUMMARY_FRAGMENT}
`;

export const GET_ADVISER_QUERY = gql`
  query GetAdvisors {
    staff(staffType: "adviser") {
      ...Staff
    }
  }
  ${STAFF}
`;
